import { Badge, Divider, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { Strings } from '@app/constants';

interface Props {
  selectedPrefix: string;
  selectedCount: number;
  buttonTitle: string;
  onClickButton: VoidFunction;
}

const SelectActionBar = ({ selectedPrefix, selectedCount, buttonTitle, onClickButton }: Props) => {
  return (
    <>
      <Stack direction="row" justifyContent="space-between" p={2} px={4}>
        <Stack direction="row" alignItems="center" spacing={2.5}>
          <Badge
            badgeContent={selectedCount}
            color="primary"
            sx={{ '.MuiBadge-badge': { backgroundColor: (theme) => theme.palette.grey[700] } }}
          />
          <Typography sx={{ marginLeft: '8px' }} variant="subtitle1">
            {Strings.common.selected(selectedPrefix)}
          </Typography>
        </Stack>

        <LoadingButton
          variant="outlined"
          color="error"
          sx={{ color: 'error.dark' }}
          onClick={onClickButton}
        >
          {buttonTitle}
        </LoadingButton>
      </Stack>
      <Divider />
    </>
  );
};

export default SelectActionBar;
